import { render, staticRenderFns } from "./AssetHistory.vue?vue&type=template&id=19e9bd25&scoped=true"
import script from "./AssetHistory.vue?vue&type=script&lang=js"
export * from "./AssetHistory.vue?vue&type=script&lang=js"
import style0 from "./AssetHistory.vue?vue&type=style&index=0&id=19e9bd25&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e9bd25",
  null
  
)

export default component.exports